import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const BACKEND_ROOT = BACKEND_URL;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Public
export const getPage = (slug, lang = "de") => api.get(`/pages/${slug}`, { params: { lang } }).then((r) => r.data);
export const getPages = (lang = "de") => api.get(`/pages`, { params: { lang } }).then((r) => r.data);
export const getNews = (params = {}) => api.get(`/news`, { params }).then((r) => r.data);
export const getNewsBySlug = (slug, lang = "de") => api.get(`/news/${slug}`, { params: { lang } }).then((r) => r.data);
export const getLocations = (lang = "de") => api.get(`/locations`, { params: { lang } }).then((r) => r.data);
export const getPhysician = (lang = "de") => api.get(`/physician`, { params: { lang } }).then((r) => r.data);
export const getSettings = (lang = "de") => api.get(`/settings`, { params: { lang } }).then((r) => r.data);
export const submitLead = (data) => api.post(`/leads`, data).then((r) => r.data);

// Auth
export const login = (email, password) =>
  api.post(`/auth/login`, { email, password }).then((r) => r.data);
export const logout = () => api.post(`/auth/logout`).then((r) => r.data);
export const me = () => api.get(`/auth/me`).then((r) => r.data);

// Admin
export const adminListPages = () => api.get(`/admin/pages`).then((r) => r.data);
export const adminUpdatePage = (id, body) => api.patch(`/admin/pages/${id}`, body).then((r) => r.data);
export const adminListSections = (pageId) => api.get(`/admin/page-sections/${pageId}`).then((r) => r.data);
export const adminUpdateSection = (id, body) => api.patch(`/admin/page-sections/${id}`, body).then((r) => r.data);
export const adminCreateSection = (body) => api.post(`/admin/page-sections`, body).then((r) => r.data);
export const adminDeleteSection = (id) => api.delete(`/admin/page-sections/${id}`).then((r) => r.data);
export const adminReorderSections = (page_id, section_ids) =>
  api.post(`/admin/page-sections/reorder`, { page_id, section_ids }).then((r) => r.data);

export const adminListNews = () => api.get(`/admin/news`).then((r) => r.data);
export const adminCreateNews = (body) => api.post(`/admin/news`, body).then((r) => r.data);
export const adminUpdateNews = (id, body) => api.patch(`/admin/news/${id}`, body).then((r) => r.data);
export const adminDeleteNews = (id) => api.delete(`/admin/news/${id}`).then((r) => r.data);

export const adminListMedia = () => api.get(`/admin/media`).then((r) => r.data);
export const adminUploadMedia = (file, alt_text = "", caption = "", folder = "general") => {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("alt_text", alt_text);
  fd.append("caption", caption);
  fd.append("folder", folder);
  return api.post(`/admin/media/upload`, fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};
export const adminDeleteMedia = (id) => api.delete(`/admin/media/${id}`).then((r) => r.data);
export const adminUpdateMedia = (id, payload) => api.patch(`/admin/media/${id}`, payload).then((r) => r.data);
export const adminAutoAltText = (scope = "missing", max_items = 6) =>
  api.post(`/admin/media/auto-alt-text`, null, { params: { scope, max_items }, timeout: 120000 }).then((r) => r.data);

export const adminListLeads = () => api.get(`/admin/leads`).then((r) => r.data);
export const adminUpdateLead = (id, body) => api.patch(`/admin/leads/${id}`, body).then((r) => r.data);
export const adminDeleteLead = (id) => api.delete(`/admin/leads/${id}`).then((r) => r.data);

export const adminGetSettings = () => api.get(`/admin/settings`).then((r) => r.data);
export const adminUpdateSettings = (body) => api.put(`/admin/settings`, body).then((r) => r.data);

export const getNavigation = () => api.get(`/navigation`).then((r) => r.data);
export const adminGetNavigation = () => api.get(`/admin/navigation`).then((r) => r.data);
export const adminUpdateNavigation = (items) => api.put(`/admin/navigation`, { items }).then((r) => r.data);
export const adminOptimizeMeta = (max_items = 8) =>
  api.post(`/admin/seo/optimize-meta`, null, { params: { max_items }, timeout: 120000 }).then((r) => r.data);
export const adminRegenerateSeoFiles = () =>
  api.post(`/admin/seo/regenerate-files`, null, { timeout: 60000 }).then((r) => r.data);

export const adminGetPhysician = () => api.get(`/admin/physician`).then((r) => r.data);
export const adminUpdatePhysician = (body) => api.put(`/admin/physician`, body).then((r) => r.data);

export const adminListTranslations = (params = {}) => api.get(`/admin/translations`, { params }).then((r) => r.data);
export const adminUpdateTranslation = (key, target_en) => api.patch(`/admin/translations/${key}`, { target_en }).then((r) => r.data);
export const adminAutoTranslate = (scope = "missing") => api.post(`/admin/translations/auto-translate`, null, { params: { scope }, timeout: 180000 }).then((r) => r.data);

export const adminListLocations = () => api.get(`/admin/locations`).then((r) => r.data);
export const adminUpdateLocation = (id, body) => api.patch(`/admin/locations/${id}`, body).then((r) => r.data);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Etwas ist schiefgelaufen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e?.msg || JSON.stringify(e))).join(", ");
  return String(detail);
}

// Resolve media URL (relative -> absolute via BACKEND_ROOT)
export function resolveMedia(url) {
  if (!url) return "";
  if (/^https?:\/\//i.test(url) || url.startsWith("data:")) return url;
  return `${BACKEND_ROOT}${url}`;
}

// --- Comrocket production hotfix: public GET client cache + inflight dedupe ---
const __publicGetCache = new Map();
const __publicGetInflight = new Map();
const __PUBLIC_GET_CACHE_TTL = 60 * 1000;

const __stableParams = (params) => {
  try {
    return JSON.stringify(params || {});
  } catch (e) {
    return "";
  }
};

const __isPublicGetCacheable = (url, config = {}) => {
  if (config && config.skipClientCache) return false;

  const raw = typeof url === "string" ? url : String(url || "");
  const path = raw
    .replace(/^https?:\/\/[^/]+\/api\/?/, "")
    .replace(/^\/api\/?/, "")
    .replace(/^\//, "");

  return /^(settings|navigation|locations|physician|pages|page-sections|news|faq)(\/|$|\?)/.test(path);
};

const __originalApiGet = api.get.bind(api);

api.get = (url, config = {}) => {
  if (!__isPublicGetCacheable(url, config)) {
    return __originalApiGet(url, config);
  }

  const key = `${url}::${__stableParams(config && config.params ? config.params : {})}`;
  const now = Date.now();

  const cached = __publicGetCache.get(key);
  if (cached && now - cached.time < __PUBLIC_GET_CACHE_TTL) {
    return Promise.resolve(cached.response);
  }

  const pending = __publicGetInflight.get(key);
  if (pending) {
    return pending;
  }

  const request = __originalApiGet(url, config)
    .then((response) => {
      __publicGetCache.set(key, { time: Date.now(), response });
      __publicGetInflight.delete(key);
      return response;
    })
    .catch((error) => {
      __publicGetInflight.delete(key);
      throw error;
    });

  __publicGetInflight.set(key, request);
  return request;
};
// --- end Comrocket production hotfix ---
